module.exports = __webpack_public_path__ + "static/img/apple-store-button@3x.2e65186.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/apple-store-button@3x.png
// module id = 1094
// module chunks = 5